/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nothing[_ngcontent-%COMP%]{\n  width: 100%;\n  text-align: center;\n}\n\n.nothing[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{\n  margin-top: 0.5rem;\n  font-size: 0.4rem;\n  color: white;\n}\n\n.nothing[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{\n  margin-top: 2.5rem;\n  width: 100vw;\n}\n\n.nothing[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{\n  margin-top: 0.3rem;\n  font-size: 0.34rem;\n  color: white;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/learning-map-nothing.component.css.shim.ngstyle.js.pre-build-optimizer.js